import ObjToArr from '../../../../utils/ObjToArr'

import {
	GET_PRODUCERS,
  GET_PRODUCERS_SUCCESS,
	GET_PRODUCERS_FAIL,
	LOAD_COMPLETED
} from "./Constants"

const initialState = {
	isLoading: false,
	error: null,
	loadCompleted: false,
	producersData: null
}
export default function reducer(state = initialState, action) {
	switch(action.type) {
		case GET_PRODUCERS:
			return {
				...state,
				isLoading: true
			}
		case GET_PRODUCERS_SUCCESS:
			const { itemsSize, list } = ObjToArr(action.payload)
			return {
				...state,
				isLoading: false,
				producersData: {
					itemsSize: itemsSize,
					list: list
				}
			}
		case GET_PRODUCERS_FAIL:
			return {
				...state,
				isLoading: false,
				error: action.payload
			}
		case LOAD_COMPLETED:
			return {
				...state,
				loadCompleted: true
			}

		default:
			return state;
	}
}